import { Box } from "@mui/system";

function SearchIconJobDetails({ iconWidthAndHeight = "40" }) {
  return (
    <Box sx={{ pl: "5px" }}>
      <svg
        width={`${iconWidthAndHeight}`}
        height={`${iconWidthAndHeight}`}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1106_5461)">
          <path
            d="M39.6205 37.8238L29.2931 27.6615C31.9975 24.7233 33.6592 20.8374 33.6592 16.5614C33.6579 7.41419 26.1236 0 16.8289 0C7.53426 0 0 7.41419 0 16.5614C0 25.7085 7.53426 33.1227 16.8289 33.1227C20.8449 33.1227 24.5282 31.7337 27.4214 29.4244L37.7889 39.6267C38.294 40.1244 39.1141 40.1244 39.6193 39.6267C40.1256 39.1292 40.1256 38.3215 39.6205 37.8238ZM16.8289 30.5747C8.96462 30.5747 2.58937 24.3007 2.58937 16.5614C2.58937 8.82201 8.96462 2.54806 16.8289 2.54806C24.6933 2.54806 31.0685 8.82201 31.0685 16.5614C31.0685 24.3007 24.6933 30.5747 16.8289 30.5747Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1106_5461">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Box>
  );
}

export default SearchIconJobDetails;
